import { type CameraState, geoToTile, tileToScreen } from "./projection.js";

/** Cheap head-position rejection before consist placement and card construction. */
export function trainNearViewport(
  position: [number, number],
  camera: CameraState,
  viewport: [number, number],
  pixelRatio = 1,
  paddingTiles = 12,
): boolean {
  const scale = camera.zoom * pixelRatio;
  const [x, y] = tileToScreen(
    geoToTile(position),
    { ...camera, zoom: scale as 1 | 2 | 3 },
  );
  const padding = paddingTiles * 64 * scale;
  return x >= -viewport[0] / 2 - padding && x <= viewport[0] / 2 + padding &&
    y >= -viewport[1] / 2 - padding && y <= viewport[1] / 2 + padding;
}
